import { combineReducers } from "redux";
import {
  DASHBOARD_PROFILE_DATA,
  DASHBOARD_ADMIN_DATA,
  ADMIN_DASHBOARD_MENTOR_APPLICATION,
  VIEW_APPLICATION_DATA,
  VIEW_PREDEFINED_OPTIONS,
  GUIDED_INSTRUCTIONS,
  APPLICATION_STATUS,
  VIEW_COUNTER_OPTIONS,
  VIEW_COUNTER_SESSIONS,
  VIEW_COUNTER_HOURS,
  GET_NAMES_LIST,
  ADMIN_COHORT_APPLICATION_STATUS,
  COUNTER_COHORT_APPLICATION,
  ACTIVITY_SUMMARY_DASHBOARD,
  ACTIVITY_SUMMARY_MENTORSHIP_COUNT,
  ACTIVITY_SUMMARY_MENTORSHIP_TOTAL,
  ACTIVITY_SUMMARY_PERFORMANCE,
  ACTIVITY_SUMMARY_NULL,
  ACTIVITY_SUMMARY_LOW_ACTIVITY,
  ACTIVITY_SUMMARY_STARTUP_COUNT,
  ACTIVITY_SUMMARY_MENTORSHIP_STATUS,
  ACTIVITY_SUMMARY_COHORT_COUNT,
  EXPORT_EXCEL_COHORT,
  EXPORT_EXCEL_STARTUP,
  EXPORT_EXCEL_MENTOR,
  ADMIN_DASHBOARD_MENTOR_REQUEST,
  ADMIN_DASHBOARD_COHORT_GRAPH_DATA,
  ADMIN_DASHBOARD_MENTOR_GRAPH_DATA,
  COHORT_SPOTLIGHT_LIST,
  COHORT_SPOTLIGHT_CALENDAR,
  PUBLIC_GROUP_SESSIONS
} from "../../../../../common/constants/actionConstants";

const currentDashboardProfileList = (state = [], action) => {
  switch (action.type) {
    case DASHBOARD_PROFILE_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const currentDashboardAdminData = (state = [], action) => {
  switch (action.type) {
    case DASHBOARD_ADMIN_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const getAdminMentorApplicationList = (state = [], action) => {
  switch (action.type) {
    case ADMIN_DASHBOARD_MENTOR_APPLICATION:
      return { ...action.payload };
    default:
      return state;
  }
};

const getAdminMentorRequestList = (state = [], action) => {
  switch (action.type) {
    case ADMIN_DASHBOARD_MENTOR_REQUEST:
      return { ...action.payload };
    default:
      return state;
  }
};

const getViewApplicationData = (state = [], action) => {
  switch (action.type) {
    case VIEW_APPLICATION_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};

const getPredefineOptionsList = (state = [], action) => {
  switch (action.type) {
    case VIEW_PREDEFINED_OPTIONS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getStepperList = (state = [], action) => {
  switch (action.type) {
    case GUIDED_INSTRUCTIONS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getCountersList = (state = [], action) => {
  switch (action.type) {
    case VIEW_COUNTER_OPTIONS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getCountersSessions = (state = [], action) => {
  switch (action.type) {
    case VIEW_COUNTER_SESSIONS:
      return { ...action.payload };
    default:
      return state;
  }
};

const getCountersHours = (state = [], action) => {
  switch (action.type) {
    case VIEW_COUNTER_HOURS:
      return { ...action.payload };
    default:
      return state;
  }
};
const updateApplicationStatus = (state = [], action) => {
  switch (action.type) {
    case APPLICATION_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortApplicationStatus = (state = [], action) => {
  switch (action.type) {
    case ADMIN_COHORT_APPLICATION_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getNamesList = (state = [], action) => {
  switch (action.type) {
    case GET_NAMES_LIST:
      return { ...action.payload };
    default:
      return null;
  }
};
const getCohortApplicationCounter = (state = [], action) => {
  switch (action.type) {
    case COUNTER_COHORT_APPLICATION:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryDashboard = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_DASHBOARD:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryMentorshipCount = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_MENTORSHIP_COUNT:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryMentorshipTotal = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_MENTORSHIP_TOTAL:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryMentorshipStatus = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_MENTORSHIP_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryPerformance = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_PERFORMANCE:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryNull = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_NULL:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryLowInteraction = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_LOW_ACTIVITY:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryStartupCount = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_STARTUP_COUNT:
      return { ...action.payload };
    default:
      return state;
  }
};
const getActivitySummaryCohortCount = (state = [], action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_COHORT_COUNT:
      return { ...action.payload };
    default:
      return state;
  }
};
const getExcelMentor = (state = [], action) => {
  switch (action.type) {
    case EXPORT_EXCEL_MENTOR:
      return { ...action.payload };
    default:
      return state;
  }
};
const getExcelStartup = (state = [], action) => {
  switch (action.type) {
    case EXPORT_EXCEL_STARTUP:
      return { ...action.payload };
    default:
      return state;
  }
};
const getExcelCohort = (state = [], action) => {
  switch (action.type) {
    case EXPORT_EXCEL_COHORT:
      return { ...action.payload };
    default:
      return state;
  }
};
const adminDashCohortCounter = (state = [], action) => {
  switch (action.type) {
    case ADMIN_DASHBOARD_COHORT_GRAPH_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const adminDashMentorCounter = (state = [], action) => {
  switch (action.type) {
    case ADMIN_DASHBOARD_MENTOR_GRAPH_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const spotLightAdminList = (state = [], action) => {
  switch (action.type) {
    case COHORT_SPOTLIGHT_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const spotLightAdminCalendar = (state = [], action) => {
  switch (action.type) {
    case COHORT_SPOTLIGHT_CALENDAR:
      return { ...action.payload };
    default:
      return state;
  }
};
const publicGroupSessionData = (state = [], action) => {
  switch (action.type) {
    case PUBLIC_GROUP_SESSIONS:
      return { ...action.payload };
    default:
      return state;
  }
};

const AdminMentorReducer = combineReducers({
  currentDashboardProfileList,
  currentDashboardAdminData,
  getAdminMentorApplicationList,
  getAdminMentorRequestList,
  getViewApplicationData,
  getPredefineOptionsList,
  getStepperList,
  updateApplicationStatus,
  getCountersList,
  getCountersSessions,
  getCountersHours,
  getNamesList,
  cohortApplicationStatus,
  getCohortApplicationCounter,
  getActivitySummaryDashboard,
  getActivitySummaryPerformance,
  getActivitySummaryNull,
  getActivitySummaryLowInteraction,
  getActivitySummaryMentorshipCount,
  getActivitySummaryStartupCount,
  getActivitySummaryMentorshipTotal,
  getActivitySummaryMentorshipStatus,
  getActivitySummaryCohortCount,
  getExcelMentor,
  getExcelStartup,
  getExcelCohort,
  adminDashCohortCounter,
  adminDashMentorCounter,
  spotLightAdminList,
  spotLightAdminCalendar,
  publicGroupSessionData
});

export default AdminMentorReducer;
